export default "__VITE_ASSET__DE8mQbCN__"